export default "__VITE_ASSET__3z7EnT4s__"